module.exports = __webpack_public_path__ + "static/media/ms.f04dfc25.svg";